import React, { useEffect, useRef } from "react";
import { Card, Typography, Button } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import subscriptionService from "../services/subscriptionService";

const { Title, Text } = Typography;

const SubscriptionCancel = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const reminderSentRef = useRef(false);
  const pendingRegistrationId = searchParams.get("pendingRegistrationId");
  const isSignupFlowCancel = Boolean(pendingRegistrationId);

  useEffect(() => {
    if (reminderSentRef.current) return;
    reminderSentRef.current = true;

    if (!pendingRegistrationId) return;

    subscriptionService.markAbandonedCheckout(pendingRegistrationId).catch(() => {
      // Do not block user flow if reminder email API fails.
    });
  }, [searchParams]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <Card className="w-full max-w-xl rounded-2xl shadow-md text-center">
        <Title level={3} className="!text-[#1c5a85] !mb-2">
          Subscription Cancelled
        </Title>
        <Text className="block text-gray-600 mb-6">
          {isSignupFlowCancel
            ? "No payment was made. Please finish your signup when you are ready."
            : "No payment was made. You can subscribe again anytime."}
        </Text>
        <Button
          type="primary"
          size="large"
          className="bg-[#1e5782] hover:bg-[#184766]"
          onClick={() => navigate(isSignupFlowCancel ? "/register" : "/pricing")}
        >
          {isSignupFlowCancel ? "Back to Sign Up" : "Back to Pricing"}
        </Button>
      </Card>
    </div>
  );
};

export default SubscriptionCancel;
